import { MatchingPageTimeframes } from '@adornis/bh-matching-timeframes/components/matching-page-timeframes.js';
import type { Timeframe } from '@adornis/bh-timeframes/entities/Timeframe.js';
import '@adornis/buchungsheld-theme/components/tr-button-small.js';
import '@adornis/buchungsheld-theme/components/tr-icon.js';
import '@adornis/buchungsheld-theme/components/tr-tooltip.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { acss } from '@adornis/chemistry/directives/acss.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('matching-hautnah-page-timeframes')
export class MatchingFuldaPageTimeframes extends MatchingPageTimeframes {
  override _renderTimeframe(timeframe: Timeframe) {
    return html`
      <tr-card ${css({ width: '100%', position: 'relative', borderRadius: this.sizes.borderRadiusSecondary })}>
        ${this._isCleanupBtnVisible(timeframe)
          ? html`
              <tr-basic-card
                padding="sm"
                horizontal
                space="sm"
                ${acss({
                  position: 'absolute',
                  top: this.spacing.xs,
                  right: this.spacing.xs,
                  boxShadow: `none`,
                  color: this.colors.tone.error.shade(600),
                  cursor: 'pointer',
                  userSelect: 'none',
                  transition: 'all .2s, color .2s',

                  '&:hover': {
                    background: this.colors.tone.error.shade(50),
                    borderColor: this.colors.tone.error.shade(600),
                  },
                })}
                @click=${() => this._timeframeUserCleanup(timeframe)}
              >
                <tr-icon size="xl" type="material-outlined" ${css({ fontVariationSettings: 'normal' })}>
                  report
                </tr-icon>

                <tr-flex space="xs" center>
                  <tr-text bold ${css({ paddingTop: this.spacing.sm })}>
                    ${this._translation.translate('timeframe', 'expiredUserDataInfo', 'title')}
                  </tr-text>
                  <tr-hr ${css({ background: this.colors.tone.error.shade(200) })}></tr-hr>
                  <tr-text ${css({ fontSize: this.spacing.sm, lineHeight: this.spacing.sm })}>
                    ${this._translation.translate('timeframe', 'expiredUserDataInfo', 'description1')}
                  </tr-text>
                  <tr-text ${css({ fontSize: this.spacing.sm, lineHeight: this.spacing.sm })}>
                    ${this._translation.translate('timeframe', 'expiredUserDataInfo', 'description2')}
                  </tr-text>
                </tr-flex>
              </tr-basic-card>
            `
          : nothing}
        <tr-flex space="sm"> ${this._renderTimeFrameContent(timeframe)} </tr-flex>
      </tr-card>
    `;
  }
}
